import { Feature } from "ol";
import { Point } from "ol/geom";
import { fromLonLat } from "ol/proj";
import { Style, Icon } from "ol/style";
import { Vector as VectorSource } from "ol/source";
import { Vector as VectorLayer } from "ol/layer";

import buildingMarker from "../images/building-marker.png";

export const initializeMarker = (map, listing) => {
    let marker = new Feature({
        geometry: new Point(
            fromLonLat([parseFloat(listing['longitude']), parseFloat(listing['latitude'])])
        )
    });

    marker.setStyle(new Style({
        image: new Icon({
            crossOrigin: 'anonymous',
            src: buildingMarker
        })
    }));

    marker.marker_content = listing;

    var vectorSource = new VectorSource({
        features: [marker]
    });

    var markerVectorLayer = new VectorLayer({
        source: vectorSource,
    });

    map.addLayer(markerVectorLayer);
}